import { StorageSyncEffects, storageSync } from 'ngrx-6-store-ionic-storage';

import {AuthEffects} from '../auth/store/auth.effect';
import {PoisEffects} from '../pois/store/pois.effects';
import {TrailsEffects} from '../trails/store/trails-effects.service';
export const effects = [AuthEffects, TrailsEffects, PoisEffects, StorageSyncEffects];
